import ListingFiltersModel from '../../../filters/ListingFiltersModel'

export default class AttributeListingFiltersModel extends ListingFiltersModel {
  isTextRangeGroup (group, entity = 'attributes', displayType = group.attributeDisplayType) {
    return super.isTextRangeGroup(group, entity, displayType)
  }

  inactivateBaseFilter (entry, activeFilters, field = 'attributeId') {
    return super.inactivateBaseFilter(entry, activeFilters, field)
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    let duplicateEntryIds = []
    const activeFilters = [...this.activeFilters]

    const entryId = entry.attributeId
    const duplicateEntryNames = this.duplicateNamesPerGroup[group.attributeGroupId]
    const duplicateEntryNamesForEntry = duplicateEntryNames?.find(e => {
      return e.ids.includes(entryId)
    })

    if (duplicateEntryNamesForEntry) {
      duplicateEntryIds = duplicateEntryNamesForEntry.ids
      return this.createLinkQueryStringForDuplicateEntry(group, entry, isFilterUsed, activeFilters, duplicateEntryIds)
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + entry.attributeId

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + entry.attributeId
      }
    }

    if (this.isTopLevelCategory) {
      return finalString + '/1'
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
  }
}
